import React from 'react'
import { Grid, Typography, Card, CardContent } from '@mui/material'

const ComplaintAboutBookedLesson = ({ bookedLesson }) => {
  return (
    <Card>
      <CardContent>
        <Grid container direction='column'>
          <Grid item>
            <Typography variant='h5' style={{ textAlign: 'center' }}>Thông tin khiếu nại về bài học</Typography>
          </Grid>

          <Grid item>
            <Typography variant='body1'><strong>Nội dung:</strong> {bookedLesson.complaint.content}</Typography>
          </Grid>

          <Grid item>
            <Typography variant='body1'><strong>Yêu cầu hoàn tiền học phí: </strong>{bookedLesson.complaint.isRequestedRefund ? 'Có' : 'Không'}</Typography>
          </Grid>

          <Grid item>
            <Typography variant='body1'><strong>Tình trạng: </strong>{bookedLesson.complaint.isSolved ? 'Đã giải quyết' : 'Đang chờ giải quyết'}</Typography>
          </Grid>
        </Grid>
      </CardContent>

    </Card>
  )
}

export default ComplaintAboutBookedLesson
